export class SelectOption {
  constructor(
    public title: string,
    public value: number | string,
  ) {}
}
